// @flow
import type { State, Action } from './types';

const initialState: State = {
  state: 'NONE',
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'SOCKET_CONNECTING':
      return {
        state: 'CONNECTING',
      };
    case 'SOCKET_SUBSCRIBING':
      return {
        state: 'SUBSCRIBING',
      };
    case 'SOCKET_READY':
      return {
        state: 'READY',
      };
    case 'SOCKET_DISCONNECTING':
      return {
        state: 'NONE',
      };
    case 'SOCKET_ERROR':
      return {
        state: 'ERROR',
      };
    default:
      return state;
  }
};

export default reducer;
